import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import AboutHero from "@/components/landing/about/AboutHero";
import AboutStory from "@/components/landing/about/AboutStory";
import AboutMission from "@/components/landing/about/AboutMission";
import AboutBenefits from "@/components/landing/about/AboutBenefits";
import AboutTeam from "@/components/landing/about/AboutTeam";
import CTASection from "@/components/landing/CTASection";
import { SEOHead } from "@/hooks/useSEO";
import { useLanguage } from "@/hooks/useLanguage";
import {
  StructuredDataHead,
  LLMMetadataHead,
  organizationSchema,
  createWebPageSchema,
} from "@/hooks/useStructuredData";

const AboutUs = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <SEOHead page="ueberUns" locale={language} />
      <StructuredDataHead schemas={[
        organizationSchema,
        createWebPageSchema(
          "Über uns – Die Geschichte von Chathero | AI Agent Plattform",
          "Erfahre mehr über Chathero – gegründet 2021 in München von einem erfahrenen Agenturnetzwerk. Unsere Mission: KI-gestützte Kommunikation für den Mittelstand.",
          "/ueber-uns",
          [
            { name: "Home", url: "/" },
            { name: "Über uns", url: "/ueber-uns" },
          ]
        ),
      ]} />
      <LLMMetadataHead
        title="Über uns – Die Geschichte von Chathero | AI Agent Plattform"
        description="Erfahre mehr über Chathero – gegründet 2021 in München von einem erfahrenen Agenturnetzwerk. Unsere Mission: KI-gestützte Kommunikation für den Mittelstand."
        keywords="Chathero Unternehmen, AI Startup München, Chatbot Agentur, KI Kommunikation, Team Chathero"
        canonicalUrl="https://chathero.ai/ueber-uns"
        aiCategory="Unternehmen, Über uns, Team"
        aiEntityType="About Page"
      />
      <Header />
      <main>
        <AboutHero />
        <AboutStory />
        <AboutMission />
        <AboutBenefits />
        <AboutTeam />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default AboutUs;
